<!--

Component used to display a list of documents based on a note id. The note
type must be a document list created in the admin section.

 -->
<template>
  <div class="col mt-3">
    <div v-for="docid in documentids" :key="docid">
      <document-display :documentid="docid" class="mb-3"></document-display>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import DocumentDisplay from './DocumentDisplay.vue'

export default {
  components: {
    DocumentDisplay
  },
  data () {
    return {
      documentids: []
    }
  },
  props: ['noteId'],
  mounted: function() {
    this.getDocumentIds()
  },
  computed: {
    documentLink: function() {
      return this.$helpers.staticDocs() + this.fileLocation + '/' + this.fileName
    }
  },
  methods: {
    getDocumentIds: function() {
      let local = this
      
      //ajax query
      axios({
          method: 'get',
          url: local.$helpers.api() + '/document/note/id/' + local.noteId,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'}
        })
        .then(function (res) {
          local.documentids = res.data
        })
        .catch(function (error) {
          console.log("error geting document data: ", error)
      });

    }
  }
}

</script>

<style>
</style>